import { render, staticRenderFns } from "./DossierOutsourcing.vue?vue&type=template&id=57361fc6&scoped=true&"
import script from "./DossierOutsourcing.vue?vue&type=script&lang=js&"
export * from "./DossierOutsourcing.vue?vue&type=script&lang=js&"
import style0 from "./DossierOutsourcing.vue?vue&type=style&index=0&id=57361fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57361fc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
